class AccountDrawer extends HTMLElement {
    constructor() {
        super();
        this.attachedTabEvents = false;
        this.currentPanels = [];
        this.accountContainer = this.querySelector('.account__container');
        this.overlay = this.querySelector('#AccountDrawer-Overlay');
        this.loading = this.querySelector('.loading__spinner');
        this.globalLoading = document.querySelector('.global-loading');
        this.overlay.addEventListener('click', () => this.close());
        document.addEventListener('keyup', (event) => this.handleKeyUp(event));

        this.querySelectorAll('[href^="/account/logout"]').forEach((logout) =>
            logout.addEventListener('click', this.handleLogOutButton.bind(this))
        );

        document
            .querySelectorAll('[href="#myAccountSideBar"], [data-trigger]')
            .forEach((trigger) => {
                trigger.addEventListener(
                    'click',
                    this.handleAccountTrigger.bind(this)
                );
            });

        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('logged-in') == 'true') {
            this.handleAccountTrigger(null, true);
        }
    }

    connectedCallback() {
        document.addEventListener('account:open', (event) => {
            if (event.detail) {
                if (event.detail.address) this.addressID = event.detail.address;
                if (event.detail.tab) this.open(event.detail.tab);
            } else {
                this.open('account-sidebar');
            }
        });
    }

    close() {
        this.currentPanels.forEach((panel, index) => {
            panel.classList.remove('active');
            setTimeout(() => {
                panel.remove(panel);
            }, 300);
        });
        this.currentPanels = [];

        this.classList.remove('active', 'animate');
        document.body.classList.remove('overflow-hidden');
    }

    open(tab) {
        if (tab === 'manage-subscriptions') {
            document.dispatchEvent(
                new CustomEvent('sidebar:open', {
                    detail: {
                        tab: 'my-subscriptions',
                    },
                })
            );
            return;
        }
        if (tab == 'account-sidebar') {
            this.classList.add('animate', 'active');
        } else {
            // Seperation of the global and local loading if the first tab or subtab directly activated
            if (!this.classList.contains('active'))
                this.globalLoading.classList.remove('hidden');
            this.fetchContent(tab);
        }
        if (!this.attachedTabEvents) {
            this.addEventListener('click', (event) =>
                this.attachInternalNavigation(event)
            );
            this.attachedTabEvents = true;
        }
        document.body.classList.add('overflow-hidden');
    }

    // Required for sub pages loading animation to be consistent
    toggleLoading() {
        this.loading.classList.toggle('hidden');
    }

    fetchContent(tab) {
        const urlParams = new URLSearchParams();
        urlParams.append('view', `account-${tab}`);
        if (this.addressID) urlParams.append('address', this.addressID);

        this.toggleLoading();

        fetch(getGlobalDomain(`/?${urlParams.toString()}`))
            .then((response) => response.text())
            .then((html) => this.createSubDrawer(html))
            .catch((error) => {
                console.error('Error fetching drawer content:', error);
            })
            .finally(() => {
                this.classList.add('animate', 'active');
                this.globalLoading.classList.add('hidden');
                this.toggleLoading();
            });
    }

    generatePanel(html) {
        // This is need so that on the snippet i can get the js scripts for them to run as normal append does not trigger the scripts.
        const fragment = document.createRange().createContextualFragment(html);

        const contentWrapper = document.createElement('div');
        contentWrapper.className = 'drawer-sub-menu-sidebar__inner';

        contentWrapper.appendChild(fragment);

        return contentWrapper;
    }

    createSubDrawer(html) {
        const panel = this.generatePanel(html);
        this.accountContainer.append(panel);
        this.currentPanels.push(panel);
        requestAnimationFrame(() => {
            panel.classList.add('active');
        });

        this.attachCloseEvents();
    }

    attachInternalNavigation(event) {
        let target = event.target.closest('[data-tab]');
        if (target) {
            const tab = target.getAttribute('data-tab');
            this.addressID = target.getAttribute('data-id');
            if (tab) {
                this.open(tab);
            }
        }
    }

    attachCloseEvents() {
        const lastPanel = this.currentPanels[this.currentPanels.length - 1];
        const lastPanelClose = lastPanel.querySelector('.drawer__close');
        if (lastPanelClose)
            lastPanelClose.addEventListener('click', () => {
                lastPanel.classList.remove('active');
                setTimeout(() => lastPanel.remove(), 300);
                this.currentPanels.pop();
            });
    }

    handleLogOutButton(event) {
        event.preventDefault();
        fetch(event.target.href).then(
            () => (window.location.href = getGlobalDomain(`?logged-out=true`))
        );
    }

    handleKeyUp(event) {
        if (event.code === 'Escape') {
            this.close();
        }
    }

    handleAccountTrigger(event, openOnLogin = false) {
        let tab = '';
        if (openOnLogin) {
            tab = 'account-sidebar';
        } else {
            event.preventDefault();
            const target = event.target;
            tab = target.getAttribute('data-trigger') || 'account-sidebar';
            this.addressID = target.getAttribute('data-id');
        }
        this.open(tab);
    }
}

customElements.define('account-drawer', AccountDrawer);
